<template>
    <div style="width:100%;height:100%;">
        <modal-x :contentStyle="{ maxWidth: '800px' }" :show="xShowingLogin" @onclose="showLogin(false)">
            <div
                style="position:relative;background:white;width:300px;height:400px;margin:0 auto;border-radius:10px;padding:10px;margin-top:20px;">

                <div class="col-xs-12">
                    <h3>Login:</h3>
                </div>
                <div class="col-xs-12"><input name="login-name" v-model="loginInfo.name" type="text"
                        placeholder="Login Email" class="form-control" /> </div>
                <div class="col-xs-12"><input name="login-password" v-model="loginInfo.password" type="password"
                        placeholder="Password" class="form-control" /></div>

                <div class="col-xs-12" style="text-align:right;margin-top:10px;">
                    <input type="button" @click="login" class="btn btn-default" value="Login" />
                    <input type="button" @click="showLogin(false)" class="btn btn-default" value="Cancel" />
                </div>
                <div class="col-xs-12" style="color:red;text-align:center;">{{ loginMsg }}</div>
                <div style="position:absolute;width:100%;left:0px;bottom:10px;text-align:center;margin-top:10px;">
                    <a href="#/ForgotLogin">Forgot Password/Account</a>
                </div>
            </div>
        </modal-x>
        <layout @onLayoutChange="onLayoutChange">
            <template v-slot:topNavBrand>
                <router-link to="/">
                    <span class="navbar-brand" title="--">
                        <span class="glyphicon glyphicon-home"></span>
                        <span class="agx-shop-name"
                            style="outline: none;border-color: #9ecaed;box-shadow: 0 0 20px #9ecaed;">{{lang.navi.home}}</span>
                    </span>
                </router-link>
            </template>
            <template v-slot:topNavRight>

            </template>
            <template v-slot:topNavMenus>
                <div class="agx-nav-bar navbar-collapse collapse">
                    <ul class="nav navbar-nav">
                        <!-- <li class="dropdown">
                            <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                                aria-expanded="false">Admins <span class="caret"></span></a>
                            <ul class="dropdown-menu" style="background:white;">
                                <li><a href="/Shopping/Shop">Shop</a></li>
                                <li><a href="/Account/Settings">Settings</a></li>
                                <li><a href="/Account/Users">Users</a></li>
                                <li><a href="/Account/Shops">Shops</a></li>
                                <li><a href="/Account/Posts">Posts</a></li>
                                <li><a href="/Account/Contacts">Contacts</a></li>
                                <li><a href="/Account/DomainRoots">DomainRoots</a></li>
                            </ul>
                        </li> -->
                        <!-- <li><a href="/Account/ViewOrders"><span class="glyphicon glyphicon-check"></span> Received Orders
                            </a></li> -->
                        <li>
                            <router-link to="/orders">
                                <span class="glyphicon glyphicon-shopping-cart"></span> {{lang.navi.orders}} 
                            </router-link>
                        </li>
                        <!-- <li><a href="/Account/Logout"><span class="glyphicon glyphicon-log-out"></span> Logout </a></li> -->
                        <li><a @click.prevent="mxnPromptLogout()"><span class="glyphicon glyphicon-log-out"></span> {{lang.navi.logout}}  </a></li>
                    </ul>
                </div>
            </template>
            <template v-slot:sideMenu>
                <div class="agx-navbar-shop">
                    <!-- <div
                        style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px;font-weight:bolder;line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                        <a href="/Account/Profile">
                            <span class="glyphicon glyphicon-th"></span>
                            Account
                        </a>
                    </div> -->
                    <router-link to="/">
                        <div
                            style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; font-size: 14px; font-weight: bolder; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                            <span class="glyphicon glyphicon-blackboard"></span> {{lang.navi.dashboard}} 
                        </div>
                    </router-link>

                    <template v-if="cpdIsManager || cpdIsShopKeeper || cpdIsAdmin">
                        <router-link to="/orders">
                            <div
                                style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; font-size: 14px; font-weight: bolder; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                                <span class="glyphicon glyphicon-shopping-cart"></span> {{lang.navi.orders}} 
                            </div>
                        </router-link>
                        <!-- <a href="/Account/ViewOrders">
                            <div
                                style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; font-size: 14px; font-weight: bolder; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                                <span class="glyphicon glyphicon-usd"></span> Received Orders
                            </div>
                        </a> -->
                    </template>
                    <!-- <router-link to="shopList">
                        <div
                            style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; font-size: 14px; font-weight: bolder; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                            <span class="glyphicon glyphicon-shopping-cart"></span> ShopsList
                        </div>
                    </router-link> -->

                    <a @click.prevent="mxnPromptLogout()">
                        <div
                            style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; font-size: 14px; font-weight: bolder; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                            <span class="glyphicon glyphicon-log-out"></span>
                            {{lang.navi.logout}} 
                        </div>
                    </a>
                    <!-- <a href="/Account/Logout">
                        <div
                            style="display: block; width: 100%; height: 50px; padding: 14px 12px; font-size: 14px; font-size: 14px; font-weight: bolder; line-height: 1.42857143; border-bottom: 1px solid #ccc; ">
                            <span class="glyphicon glyphicon-log-out"></span>
                            Logout
                        </div>
                    </a> -->
                </div>
            </template>
            <template v-slot:leftBody>
                <div style="height:100%;border-right: 1px solid gray;" :style="{ 'padding-top': '60px' }">
                    <div
                        style="position: absolute; top: 1px; width: 100%; z-index: 100; box-shadow: rgb(236 236 236) 0px 10px 15px">
                    </div>
                    <div style="position:relative;height:100%;overflow:auto;padding-top:6px;">
                        <div style="width:100%;height:60px;"></div>
                    </div>
                    <div style="clear: both; width:100%;height:50px;"></div>
                </div>
            </template>
            <template v-slot:body>
                <div style="width:100%;max-height:100%;">
                    <router-view></router-view>
                    <keep-alive>
                        <router-view name="cachePostList"></router-view>
                    </keep-alive>
                    <div style="clear: both; width:100%;height:50px;"></div>
                </div>
            </template>
            <template v-slot:bottomNavCenter>
                <!-- <span class="btn glyphicon glyphicon-share" @click="onShare">
                    <span class="glyphicon glyphicon-share-alt"> </span>
                </span> -->
            </template>
        </layout>
    </div>
</template>

<script>
import modalX from '../components/base/ModalX1.vue';
//import layout from './layouts/layoutV1.vue';
import layout from '../components/layouts/Layout.vue';
//import layout from '../components/layouts/LayoutV3.vue'
import apis from '../api/extApi.js';

export default {
    components: {
        layout: layout,
        modalX: modalX
    },
    computed: {
        lang:function(){
            return this.$store.getters.lang;
        },
        xStore: function () {
            return this.$store;
        },
        xShowingLogin: function () {
            return this.$store.getters.showingLogin;
        },
        xAccount: function () {
            return this.$store.getters.account;
        },
        cpdIsAdmin: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isAdmin === true);
        },
        cpdIsShopKeeper: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isShopKeeper === true);
        },
        cpdIsManager: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isManager === true);
        },
        cpdIsAgent: function () {
            var dp = this.dashProfile;
            return dp !== null && (dp.isAgent === true);
        },
        dashProfile: function () {
            return this.$store.getters.dashProfile;
        }
    },
    data: function () {
        return {
            apiClient: apis.api,
            loginMsg: null,
            loginInfo: { name: null, password: null },
            layoutDisplay: {},
            uiApiListener: null
        }
    },
    methods: {
        onLayoutChange: function (e) {
            console.log('AppStartV2 layout', e);
            this.layoutDisplay = e.display;
        },
        login: function () {
            this.loginMsg = "";
            var info = {
                id: this.loginInfo.name, password: this.loginInfo.password
            };
            this.apiClient.loginPrms(info).done((e) => {
                if (e.ok === true) {
                    this.xStore.commit("setShowLogin", false);
                    this.xStore.commit("setAccount", e.value);
                    this.loginInfo.name = "";
                    this.loginInfo.password = "";

                    var accessToken = e.value.accessToken;
                    localStorage.setItem("agx-token", accessToken);
                    this.apiClient.netClient.setBeforeRequest(function (arg) {
                        {
                            var token = localStorage.getItem("agx-token");
                            arg.headers["Agx-CJAuth"] = token;
                        }
                    });
                    console.log('emiting loginOk');
                    this.$emit('loginok');
                } else {
                    this.loginMsg = "Login Failed";
                    this.loginInfo.password = "";
                }
            });
        },
        showLogin: function (toShow) {
            store.commit("setShowLogin", toShow);
        },
        onShare: function () {
            this.$emit("onShare");
        }
    },
    created: function () {
        //this.getDashProfilePrms();
        var selectorElm = "#app";
        console.log('dashboard created');
        this.uiApiListener = {
            onScrollResolve: function (resolve, listingPosition, to, from, savedPosition) {
                console.log("onScrollResolve", listingPosition);
                var isBackButton = (savedPosition !== null && (to.name === 'PostList'));
                //var selectorElm = ".scrolling-container";
                if (isBackButton) {
                    console.log('isBackButton');
                    document.querySelector(selectorElm).scrollTop = listingPosition.y;
                    resolve({ selector: selectorElm, offset: listingPosition });
                } else {
                    console.log('not isBackButton');
                    document.querySelector(selectorElm).scrollTop = 0;
                    resolve({ x: 0, y: 0 });
                }
            },
            onKeepPosition: function (listPageName, to, from, next) {
                var top = document.querySelector(selectorElm).scrollTop;
                console.log("onKeepPosition", listPageName, "from name", from.name, "top", top);
                if (from.name === listPageName) {
                    return top;
                }
            }
        };
        this.mxnAgxScrollApi.on(this.uiApiListener);
    },
    mounted: function () {

    }
}
</script>
